import Footer from "../components/Footer";
import NavBar from "../components/Nav/NavBar";
import Banner from "../components/ui/Banner";
import clientBanner from "../assets/images/ClientBanner.jpeg"
import ClientsContent from "../components/Clients/ClientsContent";

export default function Clients() {
  return ( 
    <div id='root' className="p-4">
        <NavBar />
        <Banner image={clientBanner} caption={"Clients"} />
        <ClientsContent />
        <Footer />
    </div>
  );
}